import { AppState } from '../meta-reducer/index';
import { Store } from '@ngrx/store';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { Injectable } from "@angular/core"
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as RecognitionRenderNormalActions from './recognition.render.normal.actions';
import { RecognitionHandlerService } from '../../providers/recognition/recognition.handler';
import { of } from 'rxjs';
import * as NewsFeedActions from '../newsfeed/newsfeed.actions';
import { RecognitionApiService } from '../../providers/api.service/recognition.api.service';

@Injectable()
export class RecognitionRenderNormalEffects {

  constructor(private actions$: Actions, private recognitionHandlerService: RecognitionHandlerService, private store: Store<AppState>, private _recognitionApiService: RecognitionApiService) { }

  
  loadRecognition$ = createEffect(() => this.actions$
    .pipe(
      ofType(RecognitionRenderNormalActions.recognitionRenderNormalRequested),
      mergeMap(action => this._recognitionApiService.getRecognitionFeedOfAccount(action.query)
        .pipe(
          catchError(error => {
            this.store.dispatch(RecognitionRenderNormalActions.recognitionRenderNormalLoadingError({ errorMessage: error.message }));
            return of({
              data: []
            });
          }),
        )),
      map((result) => {
        this.store.dispatch(NewsFeedActions.newsFeedLastUpdatedAt({ lastUpdatedAt: (new Date()).toString() }));
        return RecognitionRenderNormalActions.recognitionRenderNormalLoaded({ data: this.recognitionHandlerService.handlerRecognitionData(result?.data?.data ?? []), hasNextPage: (result?.data?.data?.length > 0), loading: false })
      })
    ))
}
